<template>
  <table class="l-form-table">
    <caption>企業の特徴<br><span>選択した特徴はアイコンとしてトップページなどに表示されます。<br>
        労働時間制度、時間外労働の起算日を入力すると、7日、30日、60日前にリマインドメールが送信されます。
    </span></caption>
    <tbody>
    <tr>
      <th><span>決算月</span></th>
      <td>
        <div class="l-select w-auto">
          <SelectBox v-model="$v.corporateFeatureInfo.$model.accountClosingMonth"
            :options="monthList"
            :selectedValue="this.corporateFeatureInfo.accountClosingMonth"></SelectBox>
        </div>
      </td>
    </tr>
    <tr>
      <th><span>企業規模</span></th>
      <td>
        <RadioButton
          :options="companyScaleTypeList"
          v-model="$v.corporateFeatureInfo.$model.companyScaleType"
        ></RadioButton>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.companyScaleMemo"
              name="corporateFeatureInfo.companyScaleMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.companyScaleMemo.$error && !$v.corporateFeatureInfo.companyScaleMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>

    <!-- 主たる業種 -->
    <tr>
      <th><span>主たる業種</span></th>
      <td>
        <div class="l-inputLabel">
          <span>大分類</span>
          <div class="l-select w-auto">
            <SelectBox
              v-model="$v.corporateFeatureInfo.$model.industoryItemId"
              :options="industoryItemArray"
              :selectedValue="this.corporateFeatureInfo.industoryItemId"
              @input="IndustoryItemChange"></SelectBox>
          </div>
          <span>中分類</span>
          <div class="l-select w-auto">
            <SelectBox
              v-model="$v.corporateFeatureInfo.$model.industorySubitemId"
              :disabled="this.industorySubitemDisabled"
              :options="industorySubitemArray"
              :selectedValue="this.corporateFeatureInfo.industorySubitemId"></SelectBox>
          </div>
        </div>
        <label class="l-inputLabel mt-20">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.mainIndustryMemo"
              name="corporateFeatureInfo.mainIndustryMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.mainIndustryMemo.$error && !$v.corporateFeatureInfo.mainIndustryMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
<!--
        <div class="industry-old-section">
          <div class="industry-old-section__inner">
            <div class="caution u-mb10">
              <p>※こちらの項目は5月末をもって消去されるため、新しく追加された業種を設定してください。</p>
            </div>
            <div class="l-inputLabel">
            <RadioButton 
              :class="l-radio"
              :options="mainIndustryTypeList"
              v-model="$v.corporateFeatureInfo.$model.mainIndustryType"
            ></RadioButton>
            </div>
          </div>
        </div>
-->
      </td>
    </tr>

    <!-- 従業員数 -->
    <tr>
      <th><span>従業員数</span></th>
      <td>
        <RadioButton
          :options="employeeNumberTypeList"
          v-model="$v.corporateFeatureInfo.$model.employeeNumberType"
        ></RadioButton>

        <div class="l-inputAccount__set">
          <span>正社員</span>
          <div class="l-inputAccount w-vshort">
            <TextBox v-model.trim="$v.corporateFeatureInfo.$model.fullTimeEmployees" type="text" name="corporateFeatureInfo.fullTimeEmployees"></TextBox>
          </div><span>名</span>
          <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.fullTimeEmployees.$error && !$v.corporateFeatureInfo.fullTimeEmployees.numeric" validation="numeric"/>
          <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.fullTimeEmployees.$error && $v.corporateFeatureInfo.fullTimeEmployees.numeric && !$v.corporateFeatureInfo.fullTimeEmployees.between" validation="between" valueMin="0" valueMax="999999"/>
        </div>

        <div class="l-inputAccount__set">
          <span>非正規社員</span>
          <div class="l-inputAccount w-vshort">
            <TextBox v-model.trim="$v.corporateFeatureInfo.$model.nonRegularEmployees" type="text" name="corporateFeatureInfo.nonRegularEmployees"></TextBox>
          </div><span>名</span>
          <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.nonRegularEmployees.$error && !$v.corporateFeatureInfo.nonRegularEmployees.numeric" validation="numeric"/>
          <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.nonRegularEmployees.$error && $v.corporateFeatureInfo.nonRegularEmployees.numeric && !$v.corporateFeatureInfo.nonRegularEmployees.between" validation="between" valueMin="0" valueMax="999999"/>
        </div>

        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.employeeNumberMemo"
              name="corporateFeatureInfo.employeeNumberMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.employeeNumberMemo.$error && !$v.corporateFeatureInfo.employeeNumberMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>

      </td>
    </tr>

    <!-- 市場 -->
    <tr>
      <th><span>市場</span></th>
      <td>
        <div class="l-inputAccount__set">
        <div class="l-select w-auto">
          <SelectBox
            v-model="$v.corporateFeatureInfo.$model.marketType" id="js-market-select"
            :options="marketTypeArray"
            :selectedValue="this.corporateFeatureInfo.marketType"
            @input="marketChange"></SelectBox>
        </div>
        <div class="l-select w-auto">
          <SelectBox
            v-model="$v.corporateFeatureInfo.$model.marketSubType" id="js-market-sub-select" :disabled="this.marketSubTypeDisabled"
            :options="marketSubTypeArray"
            :blankText="marketBlankText"
            :selectedValue="this.corporateFeatureInfo.marketSubType"></SelectBox>
        </div>
        <ValidationErrorMessage style="width:auto;padding-left:0px;" v-show="$v.corporateFeatureInfo.marketSubType.$error && !$v.corporateFeatureInfo.marketSubType.marketSelect" validation="marketSelect"/>
        </div>
      </td>
    </tr>

    <!-- 月平均所定労働時間 -->
    <tr>
      <th><span>月平均所定労働時間</span></th>
      <td>
        <div class="l-inputAccount__set">
          <label class="l-inputLabel"><div class="l-inputAccount w-vshort">
            <TextBox v-model.trim="$v.corporateFeatureInfo.$model.monthlyAverageWorkingHours" type="text" name="corporateFeatureInfo.monthlyAverageWorkingHours"></TextBox>
          </div>時間</label>
          <ValidationErrorMessage style="width:auto;" v-show="$v.corporateFeatureInfo.monthlyAverageWorkingHours.$error && !$v.corporateFeatureInfo.monthlyAverageWorkingHours.numeric" validation="numeric"/>
          <ValidationErrorMessage style="margin-left:20px;" v-show="$v.corporateFeatureInfo.monthlyAverageWorkingHours.$error && $v.corporateFeatureInfo.monthlyAverageWorkingHours.numeric && !$v.corporateFeatureInfo.monthlyAverageWorkingHours.between" validation="between" valueMin="0" valueMax="999"/>
        </div>
      </td>
    </tr>
    <!-- 年間休日 -->
    <tr>
      <th><span>年間休日</span></th>
      <td>
        <div class="l-inputAccount__set">
          <label class="l-inputLabel"><div class="l-inputAccount w-vshort">
            <TextBox v-model.trim="$v.corporateFeatureInfo.$model.annualHoliday" type="text" name="corporateFeatureInfo.annualHoliday"></TextBox>
          </div>日</label>
          <ValidationErrorMessage style="margin-left:20px;width:auto;" v-show="$v.corporateFeatureInfo.annualHoliday.$error && !$v.corporateFeatureInfo.annualHoliday.numeric" validation="numeric"/>
          <ValidationErrorMessage style="margin-left:40px;" v-show="$v.corporateFeatureInfo.annualHoliday.$error && $v.corporateFeatureInfo.annualHoliday.numeric && !$v.corporateFeatureInfo.annualHoliday.between" validation="between" valueMin="0" valueMax="366"/>
        </div>
      </td>
    </tr>

    <!-- 以下、労務用の「企業の特徴」 -->
    <tr v-if="this.planId==3">
      <th><span>ISO</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso45001"
            :value="true"
            :checked="corporateFeatureInfo.isIso45001"
            labelText="ISO45001" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso45001')" @mouseleave="toggleb('is-iso45001')">
          <span class="tooltip is-right" id="is-iso45001" >'労働安全衛生マネジメントシステムに関する国際規格 建築/建設業・製造業・での取得が多い　※経審加点あり</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso9001"
            :value="true"
            :checked="corporateFeatureInfo.isIso9001"
            labelText="ISO9001" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso9001')" @mouseleave="toggleb('is-iso9001')">
          <span class="tooltip is-right" id="is-iso9001" >'品質マネジメントシステムに関する国際規格 製造業での取得が多い</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso9000Series"
            :value="true"
            :checked="corporateFeatureInfo.isIso9000Series"
            labelText="ISO9000シリーズ" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso9000-series')" @mouseleave="toggleb('is-iso9000-series')">
          <span class="tooltip is-right" id="is-iso9000-series" >品質マネジメントシステムに関する国際規格の総称 製造業での取得が多い</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso14000Series"
            :value="true"
            :checked="corporateFeatureInfo.isIso14000Series"
            labelText="ISO14000シリーズ" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso14000-series')" @mouseleave="toggleb('is-iso14000-series')">
          <span class="tooltip is-right" id="is-iso14000-series" >環境管理全般（環境マネジメントシステム、環境監査、環境パフォーマンス、環境ラベル、ライフサイクルアセスメント）に関する国際規格の総称 製造業での取得が多い</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso14001"
            :value="true"
            :checked="corporateFeatureInfo.isIso14001"
            labelText="ISO14001" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso14001')" @mouseleave="toggleb('is-iso14001')">
          <span class="tooltip is-right" id="is-iso14001" >環境マネジメントシステムに関する国際規格 製造業での取得が多い　※経審加点あり</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>


        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso22000"
            :value="true"
            :checked="corporateFeatureInfo.isIso22000"
            labelText="ISO22000" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso22000')" @mouseleave="toggleb('is-iso22000')">
          <span class="tooltip is-right" id="is-iso22000" >食品安全マネジメントシステムに関する国際規格 食品製造業・飼料製造業・輸送/保管（食品）業での取得が多い</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso22000Series"
            :value="true"
            :checked="corporateFeatureInfo.isIso22000Series"
            labelText="ISO22000シリーズ" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso22000-series')" @mouseleave="toggleb('is-iso22000-series')">
          <span class="tooltip is-right" id="is-iso22000-series" >衛生面を含めた食品安全管理を実践するためのマネジメントシステム規格の総称 食品製造業・飼料製造業・輸送/保管（食品）業での取得が多い</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIso39001"
            :value="true"
            :checked="corporateFeatureInfo.isIso39001"
            labelText="ISO39001" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-iso39001')" @mouseleave="toggleb('is-iso39001')">
          <span class="tooltip is-right" id="is-iso39001" >道路交通事故による死者や重傷者を撲滅することを目的とした国際規格 物流関連事業や旅客事業を行う組織での取得が多い</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>
      </td>
    </tr>

    <tr v-if="this.planId==3">
      <th><span>環境・衛生</span></th>
      <td>
        <label class="l-checkbox icon-help">
        <CheckBox v-model="$v.corporateFeatureInfo.$model.isHaccp"
            :value="true"
            :checked="corporateFeatureInfo.isHaccp"
            labelText="HACCP" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-hACCP')" @mouseleave="toggleb('is-hACCP')">
          <span class="tooltip is-right" id="is-hACCP" >食品等事業者自らが食中毒菌汚染や異物混入等の危害要因（ハザード）を把握した上で、原材料の入荷から製品の出荷に至る全工程の中で,それらの危害要因を除去又は低減させるために特に重要な工程を管理し、製品の安全性を確保しようとする衛生管理の手法</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isEcoAction21"
            :value="true"
            :checked="corporateFeatureInfo.isEcoAction21"
            labelText="エコアクション21" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-eco-action21')" @mouseleave="toggleb('is-eco-action21')">
          <span class="tooltip is-right" id="is-eco-action21" >環境省が策定した、日本独自の環境マネジメントシステム（ EMS- Environmental Management System）</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isEcoStage"
            :value="true"
            :checked="corporateFeatureInfo.isEcoStage"
            labelText="エコステージ" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-eco-stage')" @mouseleave="toggleb('is-eco-stage')">
          <span class="tooltip is-right" id="is-eco-stage" >環境マネジメントシステム規格の認証制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isGreenManagement"
            :value="true"
            :checked="corporateFeatureInfo.isGreenManagement"
            labelText="グリーン経営認証制度" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-green-management')" @mouseleave="toggleb('is-green-management')">
          <span class="tooltip is-right" id="is-green-management" >環境保全を目的にした取り組みを行っている運輸事業者（トラック、バス、タクシー、旅客船、内航海運、港湾運送、倉庫）に対する認証制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isEnvironmentalPlanner"
            :value="true"
            :checked="corporateFeatureInfo.isEnvironmentalPlanner"
            labelText="環境プランナー報告書" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-environmental-planner')" @mouseleave="toggleb('is-environmental-planner')">
          <span class="tooltip is-right" id="is-environmental-planner" >企業が環境問題に対処するために必要な各種の経営知識とそれに関連する実務全般を習得したこと、事業所向けに環境全般のアドバイスができる能力を持つことを示す環境資格</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>
      </td>
    </tr>

    <tr v-if="this.planId==3">
      <th><span>情報セキュリティ</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isIsmsCert"
            :value="true"
            :checked="corporateFeatureInfo.isIsmsCert"
            labelText="ISMS認証" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-isms-cert')" @mouseleave="toggleb('is-isms-cert')">
          <span class="tooltip is-right" id="is-isms-cert" >情報セキュリティマネジメントシステム（ISMS）適合性評価制度は、国際的に整合性のとれた情報セキュリティマネジメントシステムに対する第三者適合性評価制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isSecurityAction"
            :value="true"
            :checked="corporateFeatureInfo.isSecurityAction"
            labelText="SECURITY ACTION" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('security-action')" @mouseleave="toggleb('security-action')">
          <span class="tooltip is-right" id="security-action" >IPAによる情報セキュリティ対策の制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isTrustEmark"
            :value="true"
            :checked="corporateFeatureInfo.isTrustEmark"
            labelText="TRUSTeマーク" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('TRUSTe-mark')" @mouseleave="toggleb('TRUSTe-mark')">
          <span class="tooltip is-right" id="TRUSTe-mark" >日本プライバシー認証機構によるWebサイト・携帯サイトに関する個人情報保護の認証制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isPrivacyMark"
            :value="true"
            :checked="corporateFeatureInfo.isPrivacyMark"
            labelText="プライバシーマーク制度" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('privacy-mark')" @mouseleave="toggleb('privacy-mark')">
          <span class="tooltip is-right" id="privacy-mark" >JIPDEC（日本情報経済社会推進協会）による認証制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

      </td>
    </tr>

    <tr v-if="this.planId==3">
      <th><span>その他</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isSuperCert"
            :value="true"
            :checked="corporateFeatureInfo.isSuperCert"
            labelText="スーパー認定事業所制度" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-super-cert')" @mouseleave="toggleb('is-super-cert')">
          <span class="tooltip is-right" id="is-super-cert" >多様化する災害、プラントの高経年化、熟練従業員の減少等に対応するため、IoT、ビッグデータの活用、高度なリスクアセスメント、第三者による保安力の評価の活用等の高度な保安の取組を行っている認定事業者を</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isBcpCert"
            :value="true"
            :checked="corporateFeatureInfo.isBcpCert"
            labelText="地方自治体のＢＣＰ優良認定制度" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-bcp-cert')" @mouseleave="toggleb('is-bcp-cert')">
          <span class="tooltip is-right" id="is-bcp-cert" >中小企業が策定したBCP</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isResilienceCert"
            :value="true"
            :checked="corporateFeatureInfo.isResilienceCert"
            labelText="レジリエンス認証" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-resilience-cert')" @mouseleave="toggleb('is-resilience-cert')">
          <span class="tooltip is-right" id="is-resilience-cert" >内閣官房国土強靱化室からのガイドラインに基づき一般社団法人レジリエンスジャパン推進協議会が、「国土強靱化貢献団体認証」として行うもの</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isGMark"
            :value="true"
            :checked="corporateFeatureInfo.isGMark"
            labelText="貨物自動車運送事業安全性評価事業(Gマーク制度)" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-g-mark')" @mouseleave="toggleb('is-g-mark')">
          <span class="tooltip is-right" id="is-g-mark" >利用者が安全性の高い事業者を選びやすくする等の観点から、輸送の安全の確保に積極的に取り組んでいる事業所を認定する制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isTransportationSafetyManagement"
            :value="true"
            :checked="corporateFeatureInfo.isTransportationSafetyManagement"
            labelText="国土交通省による「運輸安全マネジメント評価の実施」または「運輸安全マネジメント認定セミナー」の受講" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-transportation-safety-management')" @mouseleave="toggleb('is-transportation-safety-management')">
          <span class="tooltip is-right" id="is-transportation-safety-management" >「運輸安全マネジメント評価」：運輸事業者の安全管理体制の向上を目的に、国及び民間の第三者機関が各事業者の運輸安全マネジメントについての取組状況を書面や面談等により確認し、評価事項や助言事項を示した「運輸安全マネジメント評価報告書」を作成・交付する制度　「運輸安全マネジメント認定セミナー」：運輸安全マネジメント制度の普及・啓発を図るため、民間機関等が実施する運輸安全マネジメントセミナー等の中で、一定の基準を満たし、事業者の安全管理体制の構築・強化に有効であると国土交通省が「認定」したセミナー</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isSafetyBus"
            :value="true"
            :checked="corporateFeatureInfo.isSafetyBus"
            labelText="貸切バス事業者安全性評価認定制度(セーフティーバス)" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-safety-bus')" @mouseleave="toggleb('is-safety-bus')">
          <span class="tooltip is-right" id="is-safety-bus" >日本バス協会において、貸切バス事業者からの申請に基づき安全性や安全の確保に向けた取組状況について評価認定を行い、これを公表するもの</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isBusinessContinuationAuthSystem"
            :value="true"
            :checked="corporateFeatureInfo.isBusinessContinuationAuthSystem"
            labelText="中小企業庁の事業継続力強化計画認定制度" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-business-continuation-auth-system')" @mouseleave="toggleb('is-business-continuation-auth-system')">
          <span class="tooltip is-right" id="is-business-continuation-auth-system" >中小企業が策定した防災・減災の事前対策に関する計画を経済産業大臣が「事業継続力強化計画」として認定する制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isGuidelineResilienceCert"
            :value="true"
            :checked="corporateFeatureInfo.isGuidelineResilienceCert"
            labelText="内閣官房国土強靱化推進室のガイドラインに基づくレジリエンス認証" />
        </label>
        <label class="icon-help"
          data-tooltip=""
          @mouseover="toggle('is-guideline-resilience-cert')" @mouseleave="toggleb('is-guideline-resilience-cert')">
          <span class="tooltip is-right" id="is-guideline-resilience-cert" >国土強靭化の趣旨に賛同し、事業継続に関する取組を積極的に行っている事業者を「国土強靭化貢献団体」として、内閣官房国土強靭化推進室が認証する制度</span>
          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
        </label>

      </td>
    </tr>

    <tr v-if="this.planId != 3">
      <th><span>給与</span></th>
      <td>
        <div class="select-group">
          <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.hasInputClosingDueDate"
              :value="true"
              :checked="corporateFeatureInfo.hasInputClosingDueDate"
              labelText="締支払日" />
            <div class="select-label">（</div>
            <div class="l-select w-auto day">
              <SelectBox v-model="$v.corporateFeatureInfo.$model.payrollClosingDate"
                :options="payrollClosingDateList"
                :needsBlank=false
                :selectedValue="this.corporateFeatureInfo.payrollClosingDate"></SelectBox>
            </div>
            <div class="select-label">締</div>
            <div class="l-select w-auto">
              <SelectBox v-model="$v.corporateFeatureInfo.$model.payrollPaymentTimeType"
                :options="payrollPaymentTimeTypeList"
                :needsBlank=false
                :selectedValue="this.corporateFeatureInfo.payrollPaymentTimeType"></SelectBox>
            </div>
            <div class="l-select w-auto day">
              <SelectBox v-model="$v.corporateFeatureInfo.$model.payrollDueDate"
                :options="dayList"
                :needsBlank=false
                :selectedValue="this.corporateFeatureInfo.payrollDueDate"></SelectBox>
            </div>
            <div class="select-label">払い）</div>
          </label>
        </div>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isMonthlyPay"
            :value="true"
            :checked="corporateFeatureInfo.isMonthlyPay"
            labelText="月給" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isDailyPay"
            :value="true"
            :checked="corporateFeatureInfo.isDailyPay"
            labelText="日給" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isHourlyWage"
            :value="true"
            :checked="corporateFeatureInfo.isHourlyWage"
            labelText="時給" />
        </label>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.payrollMemo"
              name="corporateFeatureInfo.payrollMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.payrollMemo.$error && !$v.corporateFeatureInfo.payrollMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>
    <tr v-if="this.planId != 3">
      <th><span>雇用形態</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isRegularEmployee"
            :value="true"
            :checked="corporateFeatureInfo.isRegularEmployee"
            labelText="正社員" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isFixedTermContractEmployee"
            :value="true"
            :checked="corporateFeatureInfo.isFixedTermContractEmployee"
            labelText="有期契約社員" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isPartTimerIndefinite"
            :value="true"
            :checked="corporateFeatureInfo.isPartTimerIndefinite"
            labelText="パートタイマー（無期）" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isPartTimerFixedTerm"
            :value="true"
            :checked="corporateFeatureInfo.isPartTimerFixedTerm"
            labelText="パートタイマー（有期）" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isConsignmentEmployee"
            :value="true"
            :checked="corporateFeatureInfo.isConsignmentEmployee"
            labelText="委託社員" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isSecondmentSource"
            :value="true"
            :checked="corporateFeatureInfo.isSecondmentSource"
            labelText="出向（元）" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isSecondmentDestination"
            :value="true"
            :checked="corporateFeatureInfo.isSecondmentDestination"
            labelText="出向（先）" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isTempingSource"
            :value="true"
            :checked="corporateFeatureInfo.isTempingSource"
            labelText="派遣（元）" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isDispatchDestination"
            :value="true"
            :checked="corporateFeatureInfo.isDispatchDestination"
            labelText="派遣（先）" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.isForeigner"
            :value="true"
            :checked="corporateFeatureInfo.isForeigner"
            labelText="外国人" />
        </label>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.employmentStatusMemo"
              name="corporateFeatureInfo.employmentStatusMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.employmentStatusMemo.$error && !$v.corporateFeatureInfo.employmentStatusMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>
    <tr v-if="this.planId != 3">
      <th><span>労働時間制度</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.lessThanWorkingEightTime"
            :value="true"
            :checked="corporateFeatureInfo.lessThanWorkingEightTime"
            labelText="8時間未満" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.workingEightTime"
            :value="true"
            :checked="corporateFeatureInfo.workingEightTime"
            labelText="8時間" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.weeksFortyFourTimeWork"
            :value="true"
            :checked="corporateFeatureInfo.weeksFortyFourTimeWork"
            labelText="週44時間" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.oneMonthsUnitChange"
            :value="true"
            :checked="corporateFeatureInfo.oneMonthsUnitChange"
            labelText="1ヶ月単位変形" />
        </label>
        <div class="select-group">
          <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.oneYearsUnitChange"
              :value="true"
              :checked="corporateFeatureInfo.oneYearsUnitChange"
              labelText="1年単位変形" />
            <div class="select-label">（起算日</div>
            <div class="date">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.oneYearsUnitChangeStartMonth"
                  :options="monthList"
                  :selectedValue="this.corporateFeatureInfo.oneYearsUnitChangeStartMonth"></SelectBox>
              </div>
              <div class="l-select w-auto day">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.oneYearsUnitChangeStartDay"
                  :options="dayList"
                  :needsBlank=false
                  :selectedValue="this.corporateFeatureInfo.oneYearsUnitChangeStartDay"></SelectBox>
              </div>
            </div>
            <div class="select-label"> ）</div>
          </label>
        </div>
        <div class="select-group">
            <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.isFlexWork"
                :value="true"
                :checked="corporateFeatureInfo.isFlexWork"
                labelText="フレックス" />
            </label>
            <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.discretionaryWorkSpecialized"
                :value="true"
                :checked="corporateFeatureInfo.discretionaryWorkSpecialized"
                labelText="裁量労働（専門）" />
            <div class="select-label">（起算日</div>
            <div class="date">
                <div class="l-select w-auto">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.discretionaryWorkSpecializedStartMonth"
                    :options="monthList"
                    :selectedValue="this.corporateFeatureInfo.discretionaryWorkSpecializedStartMonth"></SelectBox>
                </div>
                <div class="l-select w-auto day">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.discretionaryWorkSpecializedStartDay"
                    :options="dayList"
                    :needsBlank=false
                    :selectedValue="this.corporateFeatureInfo.discretionaryWorkSpecializedStartDay"></SelectBox>
                </div>
            </div>
            <div class="select-label"> ）</div>
            </label>
         </div>
         <div class="select-group">
            <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.discretionaryWorkPlanning"
                :value="true"
                :checked="corporateFeatureInfo.discretionaryWorkPlanning"
                labelText="裁量労働（企画）" />
            <div class="select-label">（起算日</div>
            <div class="date">
                <div class="l-select w-auto">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.discretionaryWorkPlanningStartMonth"
                    :options="monthList"
                    :selectedValue="this.corporateFeatureInfo.discretionaryWorkPlanningStartMonth"></SelectBox>
                </div>
                <div class="l-select w-auto day">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.discretionaryWorkPlanningStartDay"
                    :options="dayList"
                    :needsBlank=false
                    :selectedValue="this.corporateFeatureInfo.discretionaryWorkPlanningStartDay"></SelectBox>
                </div>
            </div>
            <div class="select-label"> ）</div>
            </label>
         </div>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.deemedOutsideOffice"
            :value="true"
            :checked="corporateFeatureInfo.deemedOutsideOffice"
            labelText="事業場外みなし" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.intermittentWork"
            :value="true"
            :checked="corporateFeatureInfo.intermittentWork"
            labelText="監視、断続労働" />
        </label>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.workingHoursSystemMemo"
              name="corporateFeatureInfo.workingHoursSystemMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.workingHoursSystemMemo.$error && !$v.corporateFeatureInfo.workingHoursSystemMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>
    <tr v-if="this.planId != 3">
      <th><span>年次有給休暇</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.timeBasedPaidHoliday"
            :value="true"
            :checked="corporateFeatureInfo.timeBasedPaidHoliday"
            labelText="時間単位年休" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.plannedPaidHoliday"
            :value="true"
            :checked="corporateFeatureInfo.plannedPaidHoliday"
            labelText="計画年休" />
        </label>
        <div class="select-group">
          <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.hasAnnualPaidTimeOffBaseDateInput"
              :value="true"
              :checked="corporateFeatureInfo.hasAnnualPaidTimeOffBaseDateInput"
              labelText="有休一斉付与基準日" />
            <div class="select-label">（</div>
            <div class="date">
              <div class="l-select w-auto month">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.annualPaidTimeOffBaseMonth"
                  :options="monthList"
                  :selectedValue="this.corporateFeatureInfo.annualPaidTimeOffBaseMonth"></SelectBox>
              </div>
              <div class="l-select w-auto day">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.annualPaidTimeOffBaseDay"
                  :options="dayList"
                  :needsBlank=false
                  :selectedValue="this.corporateFeatureInfo.annualPaidTimeOffBaseDay"></SelectBox>
              </div>
            </div>
            <div class="select-label"> ）</div>
          </label>
        </div>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.paidHolidayMemo"
              name="corporateFeatureInfo.paidHolidayMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.paidHolidayMemo.$error && !$v.corporateFeatureInfo.paidHolidayMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>
    <tr v-if="this.planId != 3">
      <th><span>時間外労働</span></th>
      <td>
        <div class="select-group">
          <label class="l-checkbox">
            <CheckBox v-model="$v.corporateFeatureInfo.$model.thirtySixAgreement"
              :value="true"
              :checked="corporateFeatureInfo.thirtySixAgreement"
              labelText="36協定" />
            <div class="select-label">（起算日</div>
            <div class="date">
              <div class="l-select w-auto month">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.thirtySixAgreementStartMonth"
                  :options="monthList"
                  :selectedValue="this.corporateFeatureInfo.thirtySixAgreementStartMonth"></SelectBox>
              </div>
              <div class="l-select w-auto day">
                <SelectBox v-model="$v.corporateFeatureInfo.$model.thirtySixAgreementStartDay"
                  :options="dayList"
                  :needsBlank=false
                  :selectedValue="this.corporateFeatureInfo.thirtySixAgreementStartDay"></SelectBox>
              </div>
            </div>
            <div class="select-label"> ）</div>
          </label>
        </div>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.hasSpecialProvision"
            :value="true"
            :checked="corporateFeatureInfo.hasSpecialProvision"
            labelText="特別条項あり" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.overtimeWorkMaxApplyingExclusion"
            :value="true"
            :checked="corporateFeatureInfo.overtimeWorkMaxApplyingExclusion"
            labelText="残業上限適用除外" />
        </label>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.overtimeWorkingMemo"
              name="corporateFeatureInfo.overtimeWorkingMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.overtimeWorkingMemo.$error && !$v.corporateFeatureInfo.overtimeWorkingMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>
    <tr v-if="this.planId != 3">
      <th><span>作成規定</span></th>
      <td>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.laborRegulations"
            :value="true"
            :checked="corporateFeatureInfo.laborRegulations"
            labelText="就業規則" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.wageAgreement"
            :value="true"
            :checked="corporateFeatureInfo.wageAgreement"
            labelText="賃金規定" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.nonRegularLaborRegulations"
            :value="true"
            :checked="corporateFeatureInfo.nonRegularLaborRegulations"
            labelText="嘱託就業規則" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.partTimerLaborRegulations"
            :value="true"
            :checked="corporateFeatureInfo.partTimerLaborRegulations"
            labelText="パートタイマー就業規則" />
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.childcareAndNursingCareLeaveRegulations"
            :value="true"
            :checked="corporateFeatureInfo.childcareAndNursingCareLeaveRegulations"
            labelText="育児介護休業規程" />
        </label>

        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.congratulatoryOrCondolencePaymentsRegulation"
            :value="true"
            :checked="corporateFeatureInfo.congratulatoryOrCondolencePaymentsRegulation"
            labelText="慶弔見舞金規程" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.carManagementProvision"
            :value="true"
            :checked="corporateFeatureInfo.carManagementProvision"
            labelText="車両管理規程" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.personallyIdInfoHandlingRegulation"
            :value="true"
            :checked="corporateFeatureInfo.personallyIdInfoHandlingRegulation"
            labelText="特定個人情報取扱規程" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.personalInfoProtectionManagementProvision"
            :value="true"
            :checked="corporateFeatureInfo.personalInfoProtectionManagementProvision"
            labelText="個人情報保護管理規程" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.teleworkRegulation"
            :value="true"
            :checked="corporateFeatureInfo.teleworkRegulation"
            labelText="テレワーク規程" />
        </label>
        <label class="l-checkbox">
          <CheckBox v-model="$v.corporateFeatureInfo.$model.disasterCompensationRegulation"
            :value="true"
            :checked="corporateFeatureInfo.disasterCompensationRegulation"
            labelText="災害補償規程" />
        </label>
        <label class="l-inputLabel mt-20" style="padding-left: 25px;">自由入力（15文字以内）
          <div class="l-inputAccount">
            <TextBox v-model="$v.corporateFeatureInfo.$model.createdRegulationMemo"
              name="corporateFeatureInfo.createdRegulationMemo"></TextBox>
            <ValidationErrorMessage v-show="$v.corporateFeatureInfo.createdRegulationMemo.$error && !$v.corporateFeatureInfo.createdRegulationMemo.maxLength" validation="maxLength" valueLength="15" />
          </div>
        </label>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import SelectBox from '@/components/parts/form/SelectBox.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import RadioButton from '@/components/parts/form/RadioButton.vue';
import constant from '@/const';
import { maxLength, numeric, requiredIf, between } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';

export default {
  components: {
    SelectBox,
    TextBox,
    RadioButton,
    CheckBox,
    ValidationErrorMessage,
  },
  props: {
    corporateFeatureInfo: {},
    planId: null,
  },
  data() {
    return {
      monthList: constant.MONTH_LIST,
      industoryItemArray: constant.INDUSTORY_ITEM,
      industorySubitemArray: [],
      marketTypeArray: constant.MARKET_TYPE,
      marketSubTypeArray: constant.MARKET_SUB_TYPE,
      dayList: constant.DAY_LIST,
      payrollClosingDateList: [],
      companyScaleTypeList: constant.COMPANY_SCALE_TYPE,
      mainIndustryTypeList: constant.MAIN_INDUSTRY_TYPE,
      employeeNumberTypeList: constant.EMPLOYEE_NUMBER_TYPE,
      payrollPaymentTimeTypeList: [
        { value: "1", label: '当' },
        { value: "2", label: '翌' },
      ],
      industorySubitemDisabled: true,
      marketSubTypeDisabled: true,
      marketBlankText: "上場、上場連結の場合選択してください",
    }
  },
  validations: {
    corporateFeatureInfo: {
      employeeNumberType: {},
      employeeNumberMemo: { maxLength: maxLength(15) },

      accountClosingMonth: {},
      companyScaleType: {},
      companyScaleMemo: { maxLength: maxLength(15) },
      mainIndustryType: {},
      mainIndustryMemo: { maxLength: maxLength(15) },
      hasInputClosingDueDate: {},
      payrollClosingDate: {},
      payrollPaymentTimeType: {},
      payrollDueDate: {},
      isMonthlyPay: {},
      isDailyPay: {},
      isHourlyWage: {},
      payrollMemo: { maxLength: maxLength(15) },
      isRegularEmployee: {},
      isFixedTermContractEmployee: {},
      isPartTimerIndefinite: {},
      isPartTimerFixedTerm: {},
      isConsignmentEmployee: {},
      isSecondmentSource: {},
      isSecondmentDestination: {},
      isTempingSource: {},
      isDispatchDestination: {},
      isForeigner: {},
      employmentStatusMemo: { maxLength: maxLength(15) },
      lessThanWorkingEightTime: {},
      workingEightTime: {},
      weeksFortyFourTimeWork: {},
      oneMonthsUnitChange: {},
      oneYearsUnitChange: {},
      oneYearsUnitChangeStartMonth: {},
      oneYearsUnitChangeStartDay: {},
      isFlexWork: {},
      discretionaryWorkSpecialized: {},

      discretionaryWorkSpecializedStartMonth: {},
      discretionaryWorkSpecializedStartDay: {},

      discretionaryWorkPlanningStartMonth: {},
      discretionaryWorkPlanningStartDay: {},

      discretionaryWorkPlanning: {},
      deemedOutsideOffice: {},
      intermittentWork: {},
      workingHoursSystemMemo: { maxLength: maxLength(15) },
      timeBasedPaidHoliday: {},
      plannedPaidHoliday: {},
      hasAnnualPaidTimeOffBaseDateInput: {},
      annualPaidTimeOffBaseMonth: {},
      annualPaidTimeOffBaseDay: {},
      paidHolidayMemo: { maxLength: maxLength(15) },
      thirtySixAgreement: {},
      thirtySixAgreementStartMonth: {},
      thirtySixAgreementStartDay: {},
      hasSpecialProvision: {},
      overtimeWorkMaxApplyingExclusion: {},
      overtimeWorkingMemo: { maxLength: maxLength(15) },
      laborRegulations: {},
      wageAgreement: {},
      nonRegularLaborRegulations: {},
      partTimerLaborRegulations: {},
      childcareAndNursingCareLeaveRegulations: {},
      congratulatoryOrCondolencePaymentsRegulation: {},
      carManagementProvision: {},
      personallyIdInfoHandlingRegulation: {},
      personalInfoProtectionManagementProvision: {},
      teleworkRegulation: {},
      disasterCompensationRegulation: {},
      createdRegulationMemo: { maxLength: maxLength(15) },
      isIso45001: {},
      isIso9001: {},
      isIso9000Series: {},
      isIso14000Series: {},
      isIso14001: {},
      isIso22000: {},
      isIso22000Series: {},
      isIso39001: {},
      isHaccp: {},
      isEcoAction21: {},
      isEcoStage: {},
      isGreenManagement: {},
      isEnvironmentalPlanner: {},
      isIsmsCert: {},
      isSecurityAction: {},
      isTrustEmark: {},
      isPrivacyMark: {},
      isSuperCert: {},
      isBcpCert: {},
      isResilienceCert: {},
      isGMark: {},
      isTransportationSafetyManagement: {},
      isSafetyBus: {},
      isBusinessContinuationAuthSystem: {},
      isGuidelineResilienceCert: {},
      industoryItemId: {},              // 業種大項目
      industorySubitemId: {},           // 業種中項目
      fullTimeEmployees: { numeric, between: between(0,999999) },   // 従業員数（正社員） 0〜999999
      nonRegularEmployees: { numeric, between: between(0,999999) }, // 従業員数（非正規社員）0〜999999
      marketType: {},                   // 市場
      marketSubType: {                  // 株式公開状況 市場で1:上場,2:上場連結が選択されているときは必須になる
        marketSelect: requiredIf(function () {
          return this.corporateFeatureInfo.marketType==1 || this.corporateFeatureInfo.marketType==2;
        })
      },
      monthlyAverageWorkingHours: { numeric,between: between(0,999) },  // 月平均所定労働時間 0〜999
      annualHoliday: { numeric, between: between(0,366) }, // 年間休日 0〜366
    }
  },
  watch: {
    corporateFeatureInfo() {
      this.inputFeatureInfo();
    }
  },
  created: function () {
    this.payrollClosingDateList = constant.DAY_LIST;
    this.payrollClosingDateList.push({ value: "99", label: '末日' });
  },
  mounted() {
    this.IndustoryItemChange();
    this.marketChange();
  },
  methods: {
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    inputFeatureInfo() {
      this.$emit("change-feature-info", {
        corporateFeatureInfo: this.corporateFeatureInfo,
        planId: this.planId,
      });
    },
    // セレクトボックスの値に応じてサブセレクトボックスを更新
    marketChange() {
      if (this.corporateFeatureInfo.marketType == 1 || this.corporateFeatureInfo.marketType == 2) {
         this.marketSubTypeDisabled = false;
      }else{
        this.corporateFeatureInfo.marketSubType = "";
         this.marketSubTypeDisabled = true;
      }
    },
    // セレクトボックスの値に応じてサブセレクトボックスを更新
    IndustoryItemChange() {
      let itemId =String(this.corporateFeatureInfo.industoryItemId);
      if ( itemId.length > 0 && itemId != '') {
        this.industorySubitemArray = constant.INDUSTORY_SUBITEM[this.corporateFeatureInfo.industoryItemId]['options'];
        this.industorySubitemDisabled = false;
      }else{
        this.industorySubitemArray = [];
        this.corporateFeatureInfo.industorySubitemId = null;
        this.industorySubitemDisabled = true;
      }
    },
  }
}

</script>
